import React from 'react';
import asyncComponentLoader from 'utils/asyncComponentLoader';
import ProtectedRoute from 'components/ProtectedRoute/Component';
import PrivacyPolicy from 'sections/PrivacyPolicy';

const routes = [
  {
    path: '/',
    element: React.createElement(asyncComponentLoader(() => import('pages/Welcome'))),
    authenticated: false,
  },
  {
    path: '/AboutUs',
    element: React.createElement(asyncComponentLoader(() => import('pages/AboutUs'))),
    authenticated: false,
  },
  {
    path: '/Login',
    element: React.createElement(asyncComponentLoader(() => import('pages/Login'))),
    authenticated: false,
  },
  {
    path: '/PrivacyPolicy',
    element: <PrivacyPolicy standalone />,
    authenticated: false,
  },
  {
    element: <ProtectedRoute />,
    authenticated: true,
    children: [
      {
        path: '/Dashboard',
        element: React.createElement(asyncComponentLoader(() => import('pages/Dashboard'))),
      },
      {
        path: '/Performance',
        element: React.createElement(asyncComponentLoader(() => import('pages/Performance'))),
      },
      {
        path: '/Image',
        element: React.createElement(asyncComponentLoader(() => import('pages/Image'))),
      },
      {
        path: '/Exposure',
        element: React.createElement(asyncComponentLoader(() => import('pages/Exposure'))),
      },
      {
        path: '/AccountSettings',
        element: React.createElement(asyncComponentLoader(() => import('pages/AccountSettings'))),
      },
    ],
  },
  {
    path: '/payment-success',
    element: React.createElement(asyncComponentLoader(() => import('components/PaymentSuccess'))),
    authenticated: false,
  },
  {
    path: '/AuthAction',
    element: React.createElement(asyncComponentLoader(() => import('pages/AuthAction'))),
    authenticated: false,
  },
  {
    path: '*',
    element: React.createElement(asyncComponentLoader(() => import('components/NotFound'))),
    authenticated: false,
  },
];

export default routes;
